<div class="modal modal_full-height">
    <span class="modal__close" matDialogClose>
      <i class="material-icons">close</i>
    </span>
  <div class="modal-header">
    <div class="form-row">
      <div class="form-col form-col-8">
        <h3 class="modal-header__title">Фінансовий моніторинг</h3>
      </div>
    </div>
  </div>
  <form class="form-flex pt-1">
    <main class="modal-content">
      <div class="mr-bottom-16 d-flex flex-direction-column">
        <div class="popup-body">
          <mat-icon class="material-icons icon">payments</mat-icon>
          <div>
            Шановний клієнте, відповідно до Закону України №361-IX (фінансовий моніторинг) та Закону України «Про
            санкції» № 1644-VII (зокрема рішення РНБО) NovaPay, як фінансова компанія зобов’язана, перш ніж провести
            фінансову операцію, перевірити клієнтів, чи немає серед них осіб, до яких застосовані санкції та які наявні
            у внутрішніх списках компанії.
            <br>
            Для пришвидшення виконання вашої фінансової операції та дотримання NovaPay всіх законодавчих вимог, просимо
            вказати вашу дату народження.
          </div>
        </div>
      </div>
    </main>
    <div class="modal-footer">
      <div class="modal-footer-buttons pr-3">
        <div class="modal-footer-buttons__item">
          <a mat-button
             class="mat-button_with-icon"
             href="https://novapay.ua/perevirka-viku/"
             target="_blank"
             >
            <mat-icon>info</mat-icon>
            Дізнатися більше
          </a>
          <button type="button"
                  color="primary"
                  mat-button
                  matDialogClose>
            Зрозуміло
          </button>
        </div>
      </div>
    </div>
  </form>
</div>
